export const meta = {
  title: 'Privacy Policy | PDFCraftTool',
  description:
    'How PDFCraftTool.org, the independent PdfCraft download and comparison guide, handles visitor data, cookies, accounts and PdfCraft Online.',
  updated_at: '2026-10-15',
};

## About this policy

PDFCraftTool operates pdfcrafttool.org, an independent guide to PdfCraft, the free and open-source PDF editor made by the ArtCraft team. The site offers PdfCraft download links, installation guides, tutorials, a feature comparison with Adobe Acrobat, and a hosted copy of the PdfCraft web app. This policy explains what information we process, why, and the choices you have. Questions go to [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org).

PDFCraftTool is not affiliated with ArtCraft or Adobe. When you install or use PdfCraft itself, the software's own license and ArtCraft's policies apply, not this one.

## You can use the site without an account

Reading the guides, comparing PdfCraft with Acrobat, downloading PdfCraft and using PdfCraft Online do not require an account, and we do not ask for your name or email to do any of them.

## PdfCraft Online and your files

PdfCraft Online is our hosted copy of the unmodified PdfCraft WebAssembly build that ArtCraft publishes at github.com/storytold/pdfcraft. It runs entirely inside your browser tab. When you open a PDF in it, the file is read by your browser on your own device and is **never uploaded** to our servers. We cannot see, store or recover the documents you open. Preferences you set in the app are kept in your browser's local storage.

## Downloads

Every PdfCraft download button links directly to the PdfCraft release files on GitHub (github.com/storytold/pdfcraft/releases). When you click one, your browser connects to GitHub, and GitHub's privacy statement applies to that request. We do not host or modify the installers.

## Information we collect automatically

- **Server and security logs:** IP address, browser and device type, requested pages, referrer and timestamps. We use these to run the site, keep it secure and investigate abuse.
- **Analytics:** we may use privacy-respecting analytics tools such as Google Analytics, Plausible or Microsoft Clarity to understand which guides are useful. These tools may use cookies or similar technologies and see pages viewed, clicks, scrolling, approximate location and device details. Clarity can create session replays and masks text typed into form fields by default.
- **Preferences:** your chosen language (a cookie) and light or dark theme (browser storage).

## Optional accounts and support

If you choose to create an account or contact support, we process your email address, name, profile picture if you sign in with Google, login sessions and the messages you send us. Transactional emails such as sign-in links are delivered by our email provider (Resend).

## Who we share information with

We share information only with providers that help us run the site, and only as needed: hosting, storage and security (Cloudflare), email delivery (Resend), sign-in (Google, if you choose it) and the analytics tools listed above. We do not sell your personal information, and we do not share it for advertising profiles. We may disclose information if the law requires it.

## Retention

Server logs are kept for a limited period for security. Analytics data is kept according to each provider's settings. Account information is kept while your account is open and deleted within 30 days after you ask us to close it, except where the law requires us to keep records.

## Your rights and choices

You can block or delete cookies in your browser, and the site will still work. You can ask to access, correct, export or delete your personal information by emailing [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org). Depending on where you live, you may also have the right to object to processing or to complain to your data protection authority.

## Children

PDFCraftTool is a general-audience technical guide and is not directed at children under 13. We do not knowingly collect personal information from children.

## Changes

We may update this policy when the site or our data practices change. The date at the top shows the latest revision.
